// @ts-nocheck
export const initialStatePageKey = 'crehanaApp';
export const SHOPPING_CART_AMPLITUDE_PAGE_NAME = 'Shopping Cart';
export const SHOPPING_CART_PAGE_KEY = 'shopping-cart';

export const SHOPPING_CART_TRACKS = {
  REMOVE_ITEM: 'SHOPPING_CART_TRACKS__REMOVE_ITEM',
  BUY_MEMBERSHIP_PROMO: 'SHOPPING_CART_TRACKS__BUY_MEMBERSHIP_PROMO',
  BUY_SHOPPING_CART: 'SHOPPING_CART_TRACKS__BUY_SHOPPING_CART',
};

export const ENROLLMENT_URL_SOURCES = {
  RECOMMENDED_COURSES: 'Recommended Courses',
  BEST_SELLER_COURSES: 'Best Seller Courses',
} as const;
